// @flow
import ButtonsStandart from './ButtonsStandart';

export default ButtonsStandart;
